import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { benefitCards } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function BenefitsGrid() {
  return <section className="bg-mp-dark py-20 md:py-28" data-id="element-29" data-mp="nqnd8ax2q098">
      <Container data-id="element-30" data-mp="ns87dzfh7h6k">
        <div className="max-w-[700px]" data-id="element-31" data-mp="jojz1ej0shk9">
          <SectionTag tone="lime" data-id="element-32" data-mp="jplmkih82wiv">No se trata de leer más</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-33" data-mp="ey3mdwn0wzyy">
            Se trata de llegar a pista con más claridad.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-34" data-mp="4zw85lk4cw0n">
          {benefitCards.map((card, i) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i % 3 * 0.05
        }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-35" data-mp="3w4w1j6skc4vl" data-mpi={i}>
              <p className="font-heading text-base uppercase tracking-wide text-mp-white" data-id="element-36" data-mp="1wub4y9u6b3kz">{card.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-37" data-mp="21t4ke7t0t4ns">{card.copy}</p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}